/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Paper, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { usePecField } from 'components/form'
import { useServerTime } from 'hooks/useServerTime'
import { calculateIdadeGestacional } from 'util/atendimento/gestante/calculateIdadeGestacional'
import { toDate } from 'util/date/formatDate'
import { MetaPath } from 'util/metaPath'

interface IgDumPaperProps {
  name: MetaPath<string>
}

export function IgDumPaper(props: IgDumPaperProps) {
  const {
    input: { value: dum },
  } = usePecField({ name: props.name })

  const theme = useTheme()

  const classes = styles(theme)

  const { getServerTimeNow } = useServerTime()

  const {
    emSemanas: { semanas, dias },
    hasIdadeGestacional,
  } = calculateIdadeGestacional(toDate(dum), getServerTimeNow())

  const fraseIgSemanasDias = hasIdadeGestacional
    ? `${'semana'.pluralizeAndConcatValue(semanas)} e ${'dia'.pluralizeAndConcatValue(dias)}`
    : 'Nenhuma DUM inserida'

  return (
    <Paper style={classes.paper}>
      <VFlow vSpacing={0.25}>
        <Text fontWeight='bold'>IG (DUM)</Text>
        <Text>{fraseIgSemanasDias}</Text>
      </VFlow>
    </Paper>
  )
}

const styles = (theme: Theme) => ({
  paper: css`
    border: 0;
    background: ${theme.pallete.surface.background};
    padding: 0.5rem;
    ${theme.breakpoints.up('lg')} {
      max-height: 3.75rem;
    }
    ${theme.breakpoints.down('lg')} {
      max-height: 4.5rem;
    }
  `,
})
